import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { map, isEmpty } from 'lodash'

import { translate } from 'parking-react-common'
import { filters, ui } from '../redux'

import Button from '../components/Button'

import './ActiveFiltersList.css'

const ActiveFiltersList = ({ activeFilters, t, dispatch }) => {
    if (isEmpty(activeFilters)) {
        return null
    }

    return (
        <div className="active-filters-list">
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            <h4>{ t('Active filters') }:</h4>
            <div>
                { map(activeFilters, (value, key) => {
                    const { name, type } = filters.parseKey(key)
                    return (
                        <Button
                            key={ `applied-filter-${name}` }
                            size={ ui.SIZE.small }
                            icon="md/clear"
                            intent={ ui.INTENT.primary }
                            label={ filters.asLabel(name, type, value) }
                            isRounded
                            onClick={ () => dispatch(filters.unset(name, type)) }
                        />
                    )
                }) }
            </div>
        </div>
    )
}

ActiveFiltersList.propTypes = {
    activeFilters: PropTypes.object
}

function mapStateToProps(state) {
    return {
        activeFilters: filters.getActive(state)
    }
}

export default translate()(connect(mapStateToProps)(ActiveFiltersList))
